import { createContext, useContext } from "react";

const EventDivisionContext = createContext({});
EventDivisionContext.displayName = "Event";

export const useEventDivision = () => useContext(EventDivisionContext).eventDivision;
export const useEventDivisionObject = () => useContext(EventDivisionContext).eventDivisionObject;
export const EventDivisionProvider = EventDivisionContext.Provider;
